import React from 'react'
import Grid from '@mui/material/Grid'
import { currency } from '@/v2/utils/format'
import { MetricCard, MetricLabel, MetricValue, MetricHint } from '../styles'

const Card = ({ label, value, hint }) => (
  <Grid item xs={12} sm={6} md={3}>
    <MetricCard elevation={0}>
      <MetricLabel>{label}</MetricLabel>
      <MetricValue>{value}</MetricValue>
      {hint ? <MetricHint>{hint}</MetricHint> : null}
    </MetricCard>
  </Grid>
)

const SummaryCards = ({ summary }) => (
  <Grid container spacing={3} sx={{ mb: 3 }}>
    <Card
      label="Total collected"
      value={currency(summary.totalCollected)}
      hint={`${summary.paymentCount} payments`}
    />
    <Card
      label="Patient fees"
      value={currency(summary.patientFees)}
      hint="Charged to patients"
    />
    <Card
      label="ACH volume"
      value={currency(summary.achVolume)}
      hint={`${summary.achCount} payments`}
    />
    {/*
      No count here: the value sums credit_card rows only, but the API sends no
      cc_count, and paymentCount - achCount counts cash and check as cards. Under
      a Cash filter that read "CC volume $0.00 / 7 non-ACH payments". A hint that
      contradicts its own value is worse than no hint.
    */}
    <Card
      label="CC volume"
      value={currency(summary.ccVolume)}
      hint="Collected on cards"
    />
    <Card
      label="ACH share"
      value={`${summary.achShare}%`}
      hint="Share of payments"
    />
  </Grid>
)

export default SummaryCards
